const EMPTY_ARRAY = []

const parseApiPermissions = (permissions) => {
    if (!permissions) return EMPTY_ARRAY

    return permissions.split(',').map((v) => v.trim())
}

export default parseApiPermissions
